module.exports = __webpack_public_path__ + "img/logo.87765da7.svg";